<template>
  <div class="player">
    <div @click="closePlayer()" class="player__overlay"></div>
    <div @click="closePlayer()" class="player__close">
      <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.3535 10.6465L21.8535 21.1465M32.3535 31.6465L21.8535 21.1465M21.8535 21.1465L32.3535 10.6465L11.3535 31.6465" stroke="white" stroke-width="2"/>
      </svg>
    </div>
    <div class="player__container">
      <div id="player"></div>
    </div>
  </div>
</template>

<script>
  import YouTubePlayer from 'youtube-player';

  export default {
    name: 'youtube-player',

    data: () => ({
      player: null,
    }),

    props: {
      videoId: {
        default: null,
        required: true,
        type: String,
      }
    },

    computed: {
    },

    methods: {
      closePlayer() {
        this.$emit('closePlayer');
      },
    },

    created() {
      this.$nextTick(() => {
        this.player = YouTubePlayer('player', {
          width: '100%',
          height: '100%',
        });
        this.player.loadVideoById(this.videoId);
      });
    },
  }
</script>
